module.exports = __webpack_public_path__ + "img/add-row.401499be.svg";